<!--
 * @Description:
 * @Author: cxh
 * @Date: 2022-06-26 18:38:35
 * @LastEditTime: 2022-07-28 15:30:18
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main class="cos-full-layout">
    <slot name="header"></slot>
    <div class="full-layout-content">
      <div class="left-layout bf" style="width: 400px">
        <slot name="aside"></slot>
      </div>
      <div class="right-layout bf">
        <slot name="main"></slot>
      </div>
    </div>
  </dc-layout-main>
</template>

<script setup lang="ts"></script>
<script lang="ts">
export default { name: 'CosLayoutMain' }
</script>

<style lang="scss" scoped>
.cos-full-layout {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding-bottom: 0px !important;
}

.full-layout-content {
  display: flex;
  width: 100%;
  flex: 1;
  .left-layout {
    margin-right: 8px;
    flex: initial;
    display: flex;
    padding: 16px 16px 0;
    flex-direction: column;
  }
  .right-layout {
    flex: 1;
    display: flex;
    padding: 16px 16px 0;
    flex-direction: column;
  }
}
.bf {
  background: #fff;
}
</style>
